/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_similarLandingItems = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
    readonly " $refType": "PdpRespContainer_similarLandingItems";
};
export type PdpRespContainer_similarLandingItems$data = PdpRespContainer_similarLandingItems;
export type PdpRespContainer_similarLandingItems$key = {
    readonly " $data"?: PdpRespContainer_similarLandingItems$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarLandingItems">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_similarLandingItems",
  "type": "moreLikeThisItemConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems",
      "args": null
    }
  ]
};
(node as any).hash = '0022f4d69cdd9fde6e1f625ad0226256';
export default node;
